import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import user from './modules/user'
import global from './modules/global'
import paperDetails from './modules/paperDetails'
import paperResult from './modules/paperResult'

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: { user, global, paperDetails, paperResult },
    getters,
})

export default store
